import { ReverseRow } from '@ahc-digital/component-library';
import { Field, ImageField, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { CreateReverseRowStoryWithVisualModel } from './C11ReverseRowStories.service';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  ImagePropertiesParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C11ReverseRowStoryWithVisualProps = RenderingProps<
  C11ReverseRowStoryWithVisualFields,
  RenderingParams
>;

export type RenderingParams = {
  ImageSide?: string;
  TitleType?: string;
  CTAStyle?: string;
  ContentVerticalAlignment?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams &
  ImagePropertiesParams;

export type C11ReverseRowStoryWithVisualFields = {
  Title?: Field<string>;
  SupportingCopy?: RichTextField;
  FirstCTA?: LinkField;
  SecondCTA?: LinkField;
  Image?: ImageField;
  VideoID?: Field<string>;
};

export const Default = (props?: C11ReverseRowStoryWithVisualProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  return (
    <ReverseRow
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateReverseRowStoryWithVisualModel(props)}
    />
  );
};
